import spintax from 'spintax'

import Lazy, { LazyError } from '../lazy'
import instagram from '../old/instagram_connector'
import { makeGenerator } from '../old/generator'

import {
  get_random,
  getCSV,
  download,
  instagramUrl,
  getURL,
  randomTimeout,
  sleep,
  skip,
} from './util'

import {
  safeMap,
} from '../old/likeItems'


export const comment_by_hashtag = {
  name: 'Comment on photos from hashtag feed',
  description: `
    Kickspan will comment on posts under a specific hashtag with whatever you input below.

    We recommend keeping comments short and simple e.g. 'Great picture 🔥' to maximise results and avoid confusion.
    
    You may choose to leave the comment combinations we have already pre set for you.
  `,
  params: [
    {
      name: 'hashtag',
      type: 'text',
      prefix: '#',
      defaultValue: 'cats',
      labelText: 'Hashtag',
    },
    {
      name: 'nPhotos',
      type: 'number',
      values: [5, 10, 15, 30, 50, 100],
      defaultValue: 5,
      labelText: 'Number of Photos',
    },
    {
      name: 'comments',
      type: 'textarea',
      defaultValue: 'Great picture 🔥 [[username]]\ngreat {photo|picture}!',
    },
  ],
  run: async ({ hashtag, nPhotos, comments }, printLog = console.log) => {
    if (!hashtag) {
      throw new Error(`Empty hashtag field!`)
    }

    printLog(`Fetching photos by hashtag: #${hashtag} ... `)

    const { items } = await instagram.request({
      method: 'get_hashtag_feed',
      params: [hashtag],
    })

    printLog(`OK, ${items.length} results`, false)
    console.log(`URLS:`, items.map(instagramUrl))

    const comment_text = item => {
      const _comment = window.comment_text
        ? window.comment_text(item)
        : get_random(comments.split('\n')).replace('[[username]]', `@${item.user.username}`)

      const comment = spintax.unspin(_comment)

      printLog(`Posting comment to ${instagramUrl(item)} : ${comment}`)

      return comment
    }

    return safeMap(
      items.slice(0, nPhotos),
      item =>
        instagram.request({
          method: 'comment',
          params: [item.id, comment_text(item)],
        }),
      printLog,
    )
  },
}

export default comment_by_hashtag
